import { Colors } from '@microfrontends/react-components'
import styled from 'styled-components'
import Image from 'next/image'

type TProps = {
	redirectLink: string
	backGroundPath: string
	bannerPath: string
	width?: number
	height?: number
}

export default function BottomSection(props: TProps) {
	const {redirectLink, backGroundPath, bannerPath, width = 485, height = 155} = props
	return (
		<BottomSectionContainer>
			<ImageWrapper>
				<Image
					src={backGroundPath}
					layout='fill'
					alt='Bottom section background'
					objectFit='cover'
				/>
			</ImageWrapper>
			<Link href={redirectLink}>
				<Image
					width={width}
					height={height}
					src={bannerPath}
					alt='Bottom section image'
				/>
			</Link>
		</BottomSectionContainer>
	)
}

const BottomSectionContainer = styled.div`
	position: relative;
	background-color: ${Colors.primary};
	padding: 15px 12px 45px 12px;
	text-align: center;
`

const ImageWrapper = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`

const Link = styled.a`
	display: inline;
`
